var map = {
	"./AdornedByNature.png": 5624,
	"./DeepTimeTrilogy.png": 194,
	"./Dorset.Map.png": 417,
	"./Logo.LymeRegisMuseum.png": 6920,
	"./MABackCover.png": 975,
	"./MAFrontAndBackCover.jpg": 8926,
	"./MAFrontCover.Preorder.png": 2043,
	"./MAFrontCover.png": 1187,
	"./MAFrontCover3D.Transparent.png": 5366,
	"./MAFrontCover3D.png": 4531,
	"./MaryAnning.YouTube.png": 2850,
	"./Museum.png": 5011,
	"./SampleImage01.png": 8885,
	"./SampleImage02.png": 7916,
	"./SampleImage03.png": 7040,
	"./SampleImage04.png": 6829,
	"./SampleImage05.png": 4738,
	"./SampleImage06.png": 6973,
	"./SampleImage07.png": 1773,
	"./SampleImage08.png": 5849,
	"./SampleImage09.png": 953,
	"./SampleImage10.png": 2916,
	"./SampleImage11.png": 4394,
	"./SampleImage12.png": 2709,
	"./SundayTelegraph.20230402.jpg": 5335,
	"./Thumbnail.Nautilus-book-cover-front.png": 4504,
	"./Thumbnail.WEG-FutureWorld-Singapore.png": 5028,
	"./Thumbnail.WEG-Lyme-Regis-Monmouth-beach-v2.png": 5818,
	"./Thumbnail.WEG-collection-and-museum.png": 5192,
	"./Thumbnail.WEG-image-small.png": 6132,
	"./Thumbnail.WEG-in-museum-collection.png": 7188,
	"./Thumbnail.WEG-in-museum.png": 7732,
	"./Thumbnail.WEG-keynote-photo-by-Nannette-Vinson.png": 9056,
	"./Thumbnail.WEG-with-kamikaze-ichthyosaur.png": 8462,
	"./Thumbnail.country-club-20230705-01.jpg": 2642,
	"./Thumbnail.country-club-20230705-02.png": 4264,
	"./Thumbnail.country-club-20230705-03.png": 5157,
	"./WEG-BookSigning.jpg": 324,
	"./WEG-FutureWorld-Singapore-small.png": 7471,
	"./WEG-FutureWorld-Singapore.jpg": 2456,
	"./WEG-Lyme-Regis-Monmouth-beach-v2.jpg": 110,
	"./WEG-image-small.jpg": 9651,
	"./WEG-in-museum-collection.Small.png": 7193,
	"./WEG-in-museum-collection.jpg": 3079,
	"./WEG-in-museum.jpg": 4263,
	"./WEG-keynote-photo-by-Nannette-Vinson.jpg": 6881,
	"./WEG-with-kamikaze-ichthyosaur.Small.png": 8442,
	"./WEG-with-kamikaze-ichthyosaur.jpg": 5010,
	"./country-club-20230705-01.jpg": 4372,
	"./country-club-20230705-02.jpg": 981,
	"./country-club-20230705-03.jpg": 1056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9640;